<template>
	<div>
		<div>
			<img src="@/assets/loginBg.cccd190.png" style="position: relative;width: 100vw;height: 100vh;">
		</div>
		<div>
			<div class="login-windows">
				<div class="login-tabs">
					<div class="login-item" v-for="(i,index) in loginModeList" :key="index">
						<span @click="loginMode = i.code">{{i.name}}</span>
						<div v-if="i.code == loginMode" class="login-item-line"></div>
					</div>
				</div>
				<div class="login-form">
					<el-form :model="loginForm" label-width="auto">
						<el-form-item>
							<el-input v-model="loginForm.account" placeholder="请输入用户名/手机号" autocomplete="username" />
						</el-form-item>
						<el-form-item>
							<el-input v-model="loginForm.password" placeholder="请输入密码" type="password"
								autocomplete="current-password" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="login(loginForm)" style="width: 100%;">登录</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<el-row>
						<el-col :span="6">
							<el-text type="primary">注册账号</el-text>
						</el-col>
						<el-col :span="6"></el-col>
						<el-col :span="6"></el-col>
						<el-col :span="6">
							<el-text type="info">忘记密码</el-text>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		name: 'loginPages',
		data() {
			return {
				loginForm: {
					account: "", //登录用户名
					password: "", //登录密码
				},
				loginMode: "password",
				loginModeList: [{
						name: "账号登录",
						code: "password"
					},
					{
						name: "验证码登录",
						code: "verificationCode"
					}
				]

			};
		},
		methods: {
			login(loginForm) {
				this.apiService.post({
						modules: "login",
						content: {
							account: loginForm.account,
							password: loginForm.password,
							mode: "password"
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							localStorage.setItem("Authorization", res.data.JwtToken);
							setTimeout(() => {
								window.location.replace("/home");
							}, 500) //跳转
						}
					})
			}
		}
	}
</script>

<style>
	.login-windows {
		position: fixed;
		width: 17vw;
		top: 22vh;
		right: 10vw;
		text-align: center;
		align-items: center;
		align-self: center;
		justify-content: center;
		background-color: #fff;
		padding: 20px 30px;
		border-radius: 10px;
	}

	.login-form {
		padding: 0 0 50px 0;
	}

	.login-tabs {
		display: flex;
		align-items: center;
		text-align: center;
		position: relative;
		width: 100%;
		justify-content: center;
		margin: 30px 0;
	}

	.login-item {
		cursor:pointer;
		margin: 0 20px;
	}

	.login-item-line {
		width: 100%;
		height: 2px;
		background-color: #409EFF;
		margin-top: 7px;
		border-radius: 30px;
	}
</style>